import { Map } from 'immutable';

export default function getCurrentUser(state: any) {
  return state.getIn(['currentUser', 'data'], Map());
}
